/*!
 *   Copyright 2022  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
:host div.modal {
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}
:host div.modal .modal-content {
  background-color: var(--warp-view-modal-bg-color, #fefefe);
  margin: 5% auto;
  padding: 20px;
  border: 1px solid #888;
  min-height: 80%;
  width: 80%; /* Could be more or less, depending on screen size */
  position: relative;
}
:host div.modal .modal-content .modal-wrapper {
  height: calc(100% - 50px);
  width: calc(100% - 40px);
  position: absolute;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 10px;
  padding-bottom: 50px;
}
:host div.modal .modal-content .modal-wrapper .discovery-dashboard-tile {
  width: 100%;
  height: 100%;
}
:host div.modal .modal-content .modal-wrapper .discovery-dashboard-tile > div {
  width: 100%;
  height: 100%;
  margin-bottom: -20px;
}
:host div.modal .close {
  color: #aaa;
  font-size: 28px;
  font-weight: bold;
  position: absolute;
  top: 0;
  right: 20px;
  z-index: 900;
}
:host div.modal .close:hover, :host div.modal .close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}